let config;
let publishableKey;
let payPalClientId = "";
let apiBaseUrl;
let photoStorageUrl;
let isProd = false;
const { io } = require("socket.io-client");
const axios = require("axios");

if (window.location.origin === "http://localhost:8080") {
  config = {
    apiKey: "AIzaSyCml2z-bXqQtBQ2Q-VCeStvATzZYxiPKNM",
    authDomain: "juke-dev-334b4.firebaseapp.com",
    databaseURL: "https://juke-dev-334b4.firebaseio.com",
    projectId: "juke-dev-334b4",
    storageBucket: "juke-dev-334b4.appspot.com",
    messagingSenderId: "916059039610",
    appId: "1:916059039610:web:d03bbac3908dfd73d298c3",
    measurementId: "G-4FM4ZKMMVX",
  };
  apiBaseUrl = "http://localhost:3000";
  publishableKey = "pk_test_scvEcCoQ3OVDQctaewC5ktCk00vs7Px6YG";
  payPalClientId =
    "AWLjSo_QYUnuXNojDXA_EGnqLRF6-24rjd7zg2E-wB3-PeaOx6zv7x9WL8cl53AJyhgiRjBl7w9ykRv8";
  photoStorageUrl = "https://storage.googleapis.com/juke-dev-334b4.appspot.com";
} else if (
  window.location.origin === "https://dev.juke.band" ||
  window.location.origin === "https://dev.juke.live"
) {
  config = {
    apiKey: "AIzaSyCml2z-bXqQtBQ2Q-VCeStvATzZYxiPKNM",
    authDomain: "juke-dev-334b4.firebaseapp.com",
    databaseURL: "https://juke-dev-334b4.firebaseio.com",
    projectId: "juke-dev-334b4",
    storageBucket: "juke-dev-334b4.appspot.com",
    messagingSenderId: "916059039610",
    appId: "1:916059039610:web:d03bbac3908dfd73d298c3",
    measurementId: "G-4FM4ZKMMVX",
  };
  apiBaseUrl = "https://staging.jukeremote.com";
  publishableKey = "pk_test_scvEcCoQ3OVDQctaewC5ktCk00vs7Px6YG";
  payPalClientId =
    "AWLjSo_QYUnuXNojDXA_EGnqLRF6-24rjd7zg2E-wB3-PeaOx6zv7x9WL8cl53AJyhgiRjBl7w9ykRv8";
  photoStorageUrl = "https://storage.googleapis.com/juke-dev-334b4.appspot.com";
} else {
  config = {
    apiKey: "AIzaSyDaRimJyanyb2C6tLfqXIH6ZdD9ykvMVm8",
    authDomain: "juke-live-de04d.firebaseapp.com",
    databaseURL: "https://juke-live-de04d.firebaseio.com",
    projectId: "juke-live-de04d",
    storageBucket: "juke-live-de04d.appspot.com",
    messagingSenderId: "171665074701",
    appId: "1:171665074701:web:27fc59470ac51c32b54344",
    measurementId: "G-J1QEVZ1CQE",
  };
  isProd = true;
  apiBaseUrl = "https://jukeremote.com";
  publishableKey = "pk_live_0afhGmhxmxGzjDY0jc8l9ObQ00uuVdU0vs";
  payPalClientId =
    "Aeyeux0Mgg9RvLPqChrwhKbdKtIx0z3EV4NwLP2fACJawKiLoIJ_ZaRx_9GvY2TW2Hwdbw0--plAlbWF";
  photoStorageUrl = "https://storage.googleapis.com/juke-live-de04d.appspot.com";
}

let socket = io.connect(apiBaseUrl, {
  transports: ["websocket"],
  secure: true,
});

const originalTrack = window.analytics.track;
let replacedTrack = false;

if (apiBaseUrl.includes("localhost") || apiBaseUrl.includes("staging")) {
  socket.on("connect", () => {
    console.log("successfully connected to socket");
  });
  socket.on("connect_error", (error) => {
    console.log("error connecting to socket", error);
  });
  setInterval(() => {
    console.log("connection status", socket.connected, socket.id);
  }, 10 * 1000);
}

socket.on("connect", () => {
  if (!replacedTrack) {
    replacedTrack = true;
    window.analytics.track = (...args) => {
      const { useNonPersistentStore } = require("./stores/nonPersistent");
      const nonPersistentStore = useNonPersistentStore();
      const [eventName, eventProperties] = args;
      if (nonPersistentStore) {
        const { uniqueId, currentUser } = nonPersistentStore;
        if (eventProperties) {
          eventProperties.uniqueSessionId = uniqueId || null;
          eventProperties.userId = currentUser?.ID || null;
        }
      }
      axios.post(`${apiBaseUrl}/user-events`, {
        eventName,
        ...eventProperties,
      });
      if (isProd) {
        if (typeof window.gtag !== "undefined") {
          window.gtag("event", eventName, eventProperties);
        }
      }
      originalTrack(eventName, eventProperties);
    };
  }
});

socket.on("disconnect", () => {
  const timeout = setTimeout(() => {
    if (socket.connected) {
      clearTimeout(timeout);
      return;
    }
    socket = io.connect(apiBaseUrl, {
      transports: ["websocket"],
      secure: true,
    });
  }, 5000);
});

const sharedConstants = {
  firestoreConfig: config,
  publishableKey: publishableKey,
  payPalClientId: payPalClientId,
  apiBaseUrl: apiBaseUrl,
  photoStorageUrl: photoStorageUrl,
  socket: socket,
  genreToColor: {
    Rock: "#713E3C",
    Funk: "#68394F",
    "Hip Hop": "#4E3A68",
    Country: "#8A6C3F",
    Blues: "#365165",
    Pop: "#3A5E47",
    Punk: "#624336",
    Metal: "#414141",
    Latin: "#618A3F",
    Alternative: "#3F5C8A",
    Tropical: "#3F8A77",
    Afro: "#8A803F",
    "R&B": "#8A3F3F",
    Gospel: "#8A3F68",
    Electronic: "#7B3F8A",
    Christian: "#3B7B3A",
    Soul: "#596D79",
    Indie: "#7B8388",
    Jazz: "#453F8A",
    Cover: "#BA51BC",
    Tribute: "#412E0D",
    "60s": "#C35858",
    "70s": "#762250",
    "80s": "#913030",
    "90s": "#6FA06F",
    "00s": "#5E486D",
  },
};

// Make sharedConstants available globally
window.$sharedConstants = sharedConstants;

export default sharedConstants;
